import Box from '@mui/material/Box';
import * as loadingAnimationData from 'core/assets/lottie/green-loader-animation.json';
import { ReactComponent as Logo } from 'core/assets/svg/loading-screen/logo.svg';
import RenderNetLoader from 'core/components/loader-renedernet/RenderNetLoader';
import LottieAnimation from 'core/layouts/components/lottie-animation/LottieAnimation';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import React from 'react';

function LoadingScreen() {
	return (
		<Box sx={[reusableStyles.fixedScreen, reusableStyles.flexCol, { gap: '32px' }]}>
			<Box id="loading-screen" sx={{ height: '150px', width: '250px' }}>
				<LottieAnimation animationData={loadingAnimationData} loop />
			</Box>
			<Logo style={{ color: colorPalette.light4 }} />
		</Box>
	);
}

export function ComponentLoadingScreen() {
	return (
		<Box
			sx={{
				position: 'fixed',
				width: '100dvw',
				height: '100dvh',
			}}
		>
			<RenderNetLoader />
		</Box>
	);
}

export default LoadingScreen;
